import { render, staticRenderFns } from "./EmpresaDetalle.vue?vue&type=template&id=1420fed7&scoped=true"
import script from "./EmpresaDetalle.vue?vue&type=script&lang=js"
export * from "./EmpresaDetalle.vue?vue&type=script&lang=js"
import style0 from "./EmpresaDetalle.vue?vue&type=style&index=0&id=1420fed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420fed7",
  null
  
)

export default component.exports